import { Dispatch } from 'react';
import getFlagValue, { FLAG_ENUM } from '../../utils/getFlagValue';
import { addQueueNCLCount, resetQueueNCLCount } from '../../../store/emarsys/action';
import { PAGE_NAME_NEW_CAR_LIST } from '../../../constants/emarsys/new-car-list';
import { IBreadcrumbs } from '../../../components/molecules/Breadcrumbs';

export default function eventClickNCL(
  dispatch: Dispatch<any>,
  customerNo: string,
  pageTitle: string = '',
  carCategory: string = '',
  carModel: string = '',
  sectionName: string = '',
  buttonName: string = '',
  breadcrumbItems?: IBreadcrumbs[],

  filter?: {
    price?: string;
    search?: string;
    color?: string;
    fuel_type?: string;
    transmission?: string;
    capacity?: string;
    tag?: string;
    order_by?: string;
  }
) {
  const isFlagActive = getFlagValue(FLAG_ENUM.EMARSYS);
  const isNewCarListActive = getFlagValue(FLAG_ENUM.EMARSYS_NEW_CAR_PURCHASE_PLP);
  if (!isFlagActive || !isNewCarListActive) return;
  if (customerNo) {
    ScarabQueue.push(['setCustomerId', customerNo]);
  }

  const valueClickAction: Record<string, string | number | boolean> = {
    page_name: PAGE_NAME_NEW_CAR_LIST.MOBIL_BARU_LISTING_PAGE,
    page_title: pageTitle || '',
    page_url: window.location.href,
    section_name: sectionName,
    button_name: buttonName,
  };

  if (breadcrumbItems?.[1]?.name) {
    valueClickAction.menu_cat_lvl1 = breadcrumbItems?.[1]?.name?.toLowerCase();
  }

  if (breadcrumbItems?.[2]?.name && carCategory) {
    valueClickAction.menu_cat_lvl2 = carCategory.toLowerCase();
  }

  if (carCategory) {
    valueClickAction.car_category = carCategory.toLowerCase();
  }
  if (carModel) {
    valueClickAction.car_model = carModel;
  }
  if (filter?.price) {
    valueClickAction.price = filter.price;
  }
  if (filter?.search) {
    valueClickAction.search = filter.search;
  }
  if (filter?.color) {
    valueClickAction.color = filter.color;
  }
  if (filter?.fuel_type) {
    valueClickAction.fueltype = filter.fuel_type;
  }
  if (filter?.transmission) {
    valueClickAction.transmission = filter.transmission;
  }
  if (filter?.capacity) {
    valueClickAction.capacity = filter.capacity;
  }
  if (filter?.tag) {
    valueClickAction.tag = filter.tag;
  }
  if (filter?.order_by) {
    valueClickAction.order_by = filter.order_by;
  }

  ScarabQueue.push(['tag', 'click_button', valueClickAction]);

  if (buttonName.includes('lihat semua')) {
    ScarabQueue.push(['go']);
    dispatch(resetQueueNCLCount());
  } else {
    dispatch(addQueueNCLCount());
  }
}
